import Handsontable from "handsontable";
import { HotHeatMapResult, HotHeatMapSingleMeta } from "..";
import { isgCountDecimalPlaces, isgNumericLocale } from "../../functions";


/**
 * Custom renderer for a single colour heat map.
 * Dynamic heat map that - configuration implementation based on the manipulation of 'isg-hm-' classes stored in the header column name
 * 
 * 1. Transforms the cell value to a color based on the value and the max value in the column
 * 2. Retrieves the background color from a custom class name stored in the column header class name
 * 3. Caches the max value in the column header class name for future use
 *
 * @param hot The Handsontable instance.
 * @param td The table cell.
 * @param row The row index.
 * @param column The column index.
 * @param prop The property.
 * @param value The value.
 * @param cellProperties The cell properties.
 */
export function isgRendererHeatMapSingle(hot: Handsontable
  , td: any
  , row: number
  , column: number
  , prop: any
  , value: any
  , cellProperties: any) {

  let meta: HotHeatMapSingleMeta = new HotHeatMapSingleMeta();

  let decimalPlaces: number = 2;

  if (value != null && !isNaN(value)) {

    // retrieve the max value from the column header class name if already set
    let colItem = hot.getColumnMeta(column);
    meta.init(column, colItem.headerClassName);

    if (meta.maxValue == null || meta.maxValue == undefined) {

      // calculate the max value from the data in the column and cache in the column header class name
      var values = hot.getDataAtCol(column);
      meta.initRangeValues(values);

      colItem.headerClassName = meta.store ?? "";
    }

    // See if we have a number format that should be applied
    if (colItem.numericFormat?.pattern) {
      decimalPlaces = isgCountDecimalPlaces(colItem.numericFormat.pattern.toString());
    }

    let res: HotHeatMapResult = meta.calcHeatmapColors(value);

    td.style.color = res.colorHm;
    td.style.background = res.colorHmBg;
  }
  else {
    td.style.color = meta.colorDefault;
    td.style.background = meta.colorDefaultBg;
  }

  td.classList.add('htRight');

  // retain any callback styling
  if (cellProperties.className && cellProperties.className.length > 0) {
    td.classList.add(cellProperties.className);
  }

  if (value != null && !isNaN(value))
    td.innerHTML = isgNumericLocale(value, decimalPlaces) + "%";
  else
    td.innerHTML = "";
}


